import axios from "axios"

const baseURL = window.location.hostname === "localhost" ? process.env.REACT_APP_LDM_URL : "#{IdentityServer_ApiBaseUrl}#";
const instance = axios.create({ baseURL: baseURL })
export default instance

export const request = ({ ...options }) => {
  const onSuccess = (response: any) => {
    return response
  }
  const onError = (error: any) => {
    return error
  }
  return instance(options).then(onSuccess).catch(onError)
}
